import { type FC, useMemo } from 'react';

import { TTgbNativedescGeneralContext } from 'shared/types/bannerContext';
import { useAdfoxBannerContext } from 'shared/components/AdfoxBannerContext';
import { useBannerEnrichments } from 'shared/hooks/useBannerEnrichments';

import { getTgbNativedescGeneralCompleteContext } from './internal/utils/getTgbNativedescGeneralCompleteContext';
import { TgbNativedescGeneralDesktopCard } from './internal/components/desktop/card/TgbNativedescGeneralDesktopCard';
import { TgbNativedescGeneralDesktopListing } from './internal/components/desktop/listing/TgbNativedescGeneralDesktopListing';
import { TgbNativedescGeneralDesktopListingJK } from './internal/components/desktop/listing/TgbNativedescGeneralDesktopListingJK';
import { TgbNativedescGeneralMobileCard } from './internal/components/mobile/card/TgbNativedescGeneralMobileCard';
import { TgbNativedescGeneralMobileListing } from './internal/components/mobile/listing/TgbNativedescGeneralMobileListing';

type TgbNativedescGeneralContainerProps = {
  context: TTgbNativedescGeneralContext;
};

export const TgbNativedescGeneralContainer: FC<TgbNativedescGeneralContainerProps> = ({ context }) => {
  const { sizes, regionId, eventEmitter, tgbNativedescGeneralDesign, containerId } = useAdfoxBannerContext();

  const bannerEnrichments = useBannerEnrichments(context);

  const completeContext = useMemo(
    () =>
      getTgbNativedescGeneralCompleteContext({
        bannerEnrichments,
        context,
        regionId,
        sizes,
      }),
    [bannerEnrichments, context, sizes, regionId],
  );

  // Мобильные форматы идут раньше, так как для их в среднем более часто вызывают
  switch (tgbNativedescGeneralDesign) {
    case 'mobile-listing':
      return <TgbNativedescGeneralMobileListing completeContext={completeContext} />;

    case 'mobile-card':
      return <TgbNativedescGeneralMobileCard completeContext={completeContext} />;

    case 'desktop-listing':
      return (
        <TgbNativedescGeneralDesktopListing
          completeContext={completeContext}
          onClose={event => {
            event.preventDefault();

            eventEmitter.emit({ containerId, event: 'close' });
          }}
        />
      );

    case 'desktop-card':
      return <TgbNativedescGeneralDesktopCard completeContext={completeContext} />;

    case 'desktop-listingJK':
      return (
        <TgbNativedescGeneralDesktopListingJK
          completeContext={completeContext}
          onClose={event => {
            event.preventDefault();

            eventEmitter.emit({ containerId, event: 'close' });
          }}
        />
      );

    default:
      return <TgbNativedescGeneralMobileCard completeContext={completeContext} />;
  }
};
